import React, {useEffect, useState} from "react";
import {epdAstralService} from "../../../../services";
import {List, Modal, notification, Row, Col} from "antd";
import Certificate from "../create-signature/certificate";
import DividerBlock from "../../../divider-block";
import {DocFlowItem} from "./docFlowItem";
import SelectField from "../../../select-field";
import i18n from "../../../../i18n";

export default function ModalJoinCompany({isShow, onCloseModal, id}) {
  const [isNeedUpdate, setIsNeedUpdate] = useState(true);
  const [points, setPoints] = useState([]);
  const [attorneysList, setAttorneysList] = useState([]);

  const [certificate, setCertificate] = useState(null);
  const [attorney, setAttorney] = useState(null);

  useEffect(() => {
    if (isShow && isNeedUpdate) {
      epdAstralService.getPoints(id)
        .then((res) => {
          setPoints(res.points);
          setAttorneysList(res.attorneys);
          setAttorney((res.attorneys && res.attorneys[0]) ? res.attorneys[0]['Id'] || null : null);
          setIsNeedUpdate(false);
        })
        .catch((err) => {
          notification.error({
            message: i18n.t('components.notification.titles.getPoints'),
            description: err,
          });
          setIsNeedUpdate(false);
        });
    }
  }, [isShow, isNeedUpdate]);

  const isCertSelectShow = points.some((point) => point.docflow.nextTitle !== "") &&
    points.some((point) => point.locked !== true);

  const handleCloseModal = () => {
    setPoints([]);
    onCloseModal(null);
    setIsNeedUpdate(true);
  }

  return (<Modal
      title={<div>{i18n.t('modals.modalJoinCompany.title')}</div>}
      cancelText={i18n.t('main.buttons.close')}
      className="modal-window"
      align={null}
      visible={isShow}
      onCancel={handleCloseModal}
      forceRender={true}
      footer={<div></div>}
    >
      {points.length > 0 &&
        <>{isCertSelectShow &&
          <>
            <DividerBlock label={i18n.t('modals.modalJoinCompany.divider.certificate')}/>
            <Certificate onChange={setCertificate}/>
            {(attorneysList && attorneysList.length) && <><DividerBlock label={i18n.t('modals.modalJoinCompany.divider.attorney')}/>
            <Row gutter={[16, 24]} >
              <Col lg={24} md={24} sm={24} sx={24}>
                <SelectField
                  name="attorney"
                  values={attorneysList}
                  selectedValue={attorney}
                  allowClear={true}
                  placeholder={i18n.t('modals.modalJoinCompany.fields.attorney.placeholder')}
                  onChange={(value) => {
                    setAttorney(value);
                  }}
                  getErrors={() => {}}
                  style={{ width: "100%" }}
                />
              </Col>
            </Row></>}
            <DividerBlock label={i18n.t('modals.modalJoinCompany.divider.docs')}/>
          </>
        }
          <List
            itemLayout="vertical"
            size="large"
            className="astral-user-companies-list"
            locale={{emptyText: i18n.t('modals.modalJoinCompany.fields.points.emptyText')}}
          >
            {points.map((item, index) => {
              return <DocFlowItem
                item={item}
                certificate={certificate}
                attorney={attorney}
                setIsNeedUpdate={setIsNeedUpdate}
                key={`list-item-${index}`}
              />
            })}
          </List>
        </>
      }
    </Modal>
  )
}
